import { render, staticRenderFns } from "./PassGuide.vue?vue&type=template&id=3aa15460&"
import script from "./PassGuide.vue?vue&type=script&lang=js&"
export * from "./PassGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports